import { Box, Flex, FloraButton, styled } from '@grupoboticario/flora-react';

import { Card, ResponsiveFloraTypography } from 'components';

const styles = {
  Card: styled(Card, {
    width: '100%',
    padding: '$4',
  }),

  Subtitle: styled(Flex, {
    height: '$6',
  }),

  Divider: styled('hr', {
    margin: '$4 0',
    border: 'solid 1px $backgroundSecondary',
  }),

  Heading: styled(ResponsiveFloraTypography, {}),

  LogoImage: styled(Box, {
    '&[data-logo]': {
      svg: {
        height: '13px',
        width: '104px',
        viewBox: '5 0 250 30',
      },
    },
  }),

  Value: styled(Flex, {
    marginBottom: '$4',
  }),

  CardHeader: styled(Flex, {
    '&[data-has-logo="true"]': {
      minHeight: '$12',
    },
  }),

  Title: styled(Flex, {
    '&[data-has-bot="true"]': {
      minHeight: '$12',
    },
  }),

  ButtonTooltip: styled(FloraButton, {
    '&[data-button-tooltip]': {
      paddingRight: '$2',
    },
  }),
};

export default styles;
